import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';
import * as _ from 'lodash';

import { ListModel } from '../shared/model/list.model';
import { ListService } from '../shared/service/list.service';
import { ListTypesTranslation } from './../shared/enum/list-type';
import { ReturnMessageModel } from '../shared/model/return-message.model';
import { MessageComponent } from '../shared/component/message/message.component';
import { IntegrationId, IntegrationIdTranslation } from '../shared/enum/integration-id';
import { ListValueModalComponent } from '../shared/component/list-value-modal/list-value-modal.component';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css']
})
export class ListComponent implements OnInit {
  [x: string]: any;

  @ViewChild(MessageComponent) message: MessageComponent;
  @ViewChild(ListValueModalComponent) modal: ListValueModalComponent;

  lastEvent: any;
  totalRecords: number;
  lists: ListModel[] = [];
  listOptions: any[] = [];
  integrationOptions: any[] = [];
  list: ListModel = new ListModel();

  selectedMethod = '';
  selectedOrdenation = '';

  ascDesc = [];
  ordenation = [];

  constructor(
    private translateService: TranslateService,
    private listService: ListService
  ) {
    this.getListOptions();
  }

  ngOnInit() {}

  lazy(e) {
    this.lastEvent = e;
    this.listService.getPaginated(e.first, e.rows).subscribe(lists => {
      this.lists = lists['rows'] as ListModel[];
      this.totalRecords = lists['count'];

      this.loadOrdenation();
    });
  }

  loadOrdenation() {
      this.ascDesc = [
      { value: 'asc', label: this.translate('asc') },
      { value: 'desc', label: this.translate('desc') },
    ];

    this.ordenation = [
      { value: 'created_at', label: this.translate('creation_date') },
      { value: 'name', label: this.translate('alph_order') },
      { value: 'list_type', label: this.translate('type') }
    ];
  }

  translate = (key: string) => this.translateService.instant(key || "invalid");
  tUpper = (key) => this.translate(key).toString().toUpperCase();
  tCap = (key) => this.translate(key).charAt(0).toUpperCase() + this.translate(key).slice(1);

  getListType = (id) => ListTypesTranslation[id] || 'selection';

  isIntegration = (list) => list && list.list_type == ListTypesTranslation['integration'];

  runIntegration = () => this.listService.integration().pipe(take(1)).subscribe(
    (r: any) => r.error ? this.message.error(r.message) : this.message.success(r.body));

  getListOptions() {
      const listKeys = Object.keys(ListTypesTranslation);
      const listOptions = listKeys.map((n) => parseInt(n)).filter(v => v || v === 0) as number[];

      const intKeys = Object.keys(IntegrationId);
      const intOptions = intKeys.map((n) => parseInt(n)).filter(v => v || v === 0) as number[];

      // listOptions.forEach((value)=> {
      //   this.listOptions.push({
      //     label: ListTypesTranslation[value],
      //     value,
      //   })
      // })
    this.translateService.get('translate_version').subscribe(_ => {   

      listOptions.forEach((value)=> {
        const realName = ListTypesTranslation[value];
        const label = this.translate(realName);

        this.listOptions.push({ label, value });
      })


      intOptions.forEach((value)=> {
        const realName = IntegrationIdTranslation[value];
        const label = this.translate(realName);

        this.integrationOptions.push({ label, value });
      })

    })
    
    // const intKeys = Object.keys(IntegrationId);
    // const intOptions = intKeys.map((n) => parseInt(n)).filter(v => v) as number[];

    //   intOptions.forEach((value)=> {
    //     this.integrationOptions.push({
    //       label: IntegrationId[value],
    //       value,
    //     })
    //   })
  }



  

  onSelect(e) {
    this.list = e.data as ListModel;
  }

  onSave() {
    this.listService.save(this.list).subscribe((r: ReturnMessageModel) => {
      if (r.error) this.message.error(r.message);
      else this.message.success(r.message);

      this.lazy(this.lastEvent);
      this.onNew();
    });
  } 

  onNew() {
    this.list = new ListModel();
  }

  onDelete(){
    this.listService.delete(this.list.id).subscribe((r: ReturnMessageModel) => {
      if (r.error) this.message.error(r.message); else this.message.success(r.message);
      this.lazy(this.lastEvent);
      this.onNew();
    });
  }

  onOpenListValueModal(listId) {
    const list = this.lists.find(l => l.id == listId);
    this.modal.onShow(listId, list);
  }

  validate(): boolean {
    return ListModel.validate(this.list) && !this.duplicateValidation();
  }

  duplicateValidation() {
    return !this.list.id && this.lists.findIndex((list) => list.name == this.list.name) > -1;
  }

  order() {
		this.lists = _.orderBy(this.lists, this.selectedOrdenation, this.selectedMethod);
  }

 
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/list/list.component.ts